<template>
  <!--  <div  v-click-outside="()=>$emit('close')" class="entryPopup">-->
  <div ref="entryPopupRef" class="entryPopup" tabindex="0" @keyup="keyPressed">
    <h4>
      {{ entryFormattedDate }}
    </h4>
    <div class="button-icon close-button" @click="$emit('close')">
      <img :src="require('@/assets/_desktop/_calendars/Close.svg')" />
    </div>
    <template v-if="isEditable">
      <div class="button-icon delete-button" @click="deleteEntry">
        <img :src="require('@/assets/_desktop/_calendars/Trash.svg')" />
      </div>
      <transition name="fade">
        <div v-if="entry.type === 'work' && isCopyPossible" class="button-icon copy-button" @click="copyEntry">
          <transition name="drop">
            <p v-if="showCopied" class="copied">
              {{ $t('copied') }}
            </p>
          </transition>
          <img :src="require('@/assets/_desktop/_calendars/Copy.svg')" />
        </div>
      </transition>
      <div class="popup-row">
        <div class="switch">
          <button
            ref="typeWork"
            class="clavo-segmented-ctrl"
            tabindex="0"
            :class="{
              active: entry.type === 'work' && !isFarInFuture,
              inactive: entry.type !== 'work' && !isFarInFuture,
              forbidden: isFarInFuture,
            }"
            @click="changeType('work')"
          >
            {{ $t('work') }}
          </button>
          <button
            ref="typeNoWork"
            class="clavo-segmented-ctrl"
            tabindex="0"
            :class="{
              active: entry.type !== 'work',
              inactive: entry.type === 'work',
            }"
            @click="changeType(timeOffType)"
          >
            {{ $t('timeOff') }}
          </button>
        </div>
      </div>
    </template>
    <div v-if="entry.type === 'work'" :key="entry.type">
      <div v-if="teams.length > 1" class="popup-row">
        <team-icon :team="team" />
        <dropdown
          v-if="isEditable && filteredTeams.length > 1"
          :key="inputTeam"
          v-model="inputTeam"
          tabindex="4"
          team
          @dropdown-opened="dropdownOpened"
          :options="filteredTeams"
          @input="changeTeam"
        />
        <div v-else>{{ inputTeam }}</div>
      </div>
      <div class="popup-row">
        <div class="circle-location" :style="{ background: inputLocation.color }" />
        <dropdown
          v-if="isEditable"
          :key="inputLocation.name"
          v-model="inputLocation.name"
          location
          @dropdown-opened="dropdownOpened"
          :object-prop="inputLocation"
          :options="locations"
          @object-changed="changeLocation"
        />
        <div v-else>{{ inputLocation.name }}</div>
      </div>
      <div class="popup-row">
        <img alt="clock" :src="require('@/assets/_desktop/_calendars/Clock.svg')" />
        <div class="multiple">
          <dropdown
            v-if="isEditable"
            :key="startTime.name"
            v-model="startTime.name"
            @dropdown-opened="dropdownOpened"
            auto-complete
            show-all
            :options="startTimeArray"
            @input="(input) => changeTime(input, 'start')"
          />
          <div v-else>{{ startTime.name }}</div>
          <img alt="dropdown" :src="require('@/assets/_desktop/_calendars/arrow-from-to.svg')" />
          <dropdown
            v-if="isEditable"
            :key="endTime.name + '1'"
            v-model="endTime.name"
            @dropdown-opened="dropdownOpened"
            auto-complete
            show-all
            :options="endTimeArray"
            @input="(input) => changeTime(input, 'end')"
          />
          <div v-else>{{ endTime.name }}</div>
        </div>
        <div class="duration">
          {{ startTime.duration }}
        </div>
      </div>
      <div v-if="inputLocation.timezone" class="popup-row">
        <img alt="Location" :src="require('@/assets/_desktop/_calendars/Time-zone.svg')" />
        <dropdown
          v-if="isEditable"
          :key="inputLocation.timezone"
          v-model="inputLocation.timezone"
          :disabled="inputLocation.singleLocation"
          :options="$store.state.timezonesGlobal"
          :editable="!inputLocation.singleLocation"
          :show-all="!inputLocation.singleLocation"
          :auto-complete="!inputLocation.singleLocation"
          @dropdown-opened="dropdownOpened"
          @focusout="textInput = false"
          @input="changeTimezone"
          @writing="changingText"
        />
        <div v-else>{{ getTimezoneName(inputLocation.timezone) }}</div>
      </div>
      <div v-if="isMyPersonal || inputComment" class="popup-row">
        <img alt="Comment" :src="require('@/assets/_desktop/_calendars/Comment.svg')" />
        <div class="textarea-wrapper">
          <textarea
            v-if="isEditable"
            id="commentId"
            v-model="inputComment"
            class="clavo-textarea"
            @focusout="changeComment"
            @focusin="textInput = true"
            @input="writingComment"
          />
          <div v-else class="comment-content">{{ inputComment }}</div>
        </div>
      </div>
    </div>
    <div v-if="entry.type !== 'work'" :key="entry.type + '2'">
      <div v-if="teams.length > 1" class="popup-row">
        <team-icon :team="team" />
        <dropdown
          v-if="isEditable && filteredTeams.length > 1"
          :key="inputTeam"
          v-model="inputTeam"
          team
          :options="filteredTeams"
          @dropdown-opened="dropdownOpened"
          @input="changeTeam"
        />
        <div v-else>{{ inputTeam }}</div>
      </div>
      <div class="popup-row">
        <img :src="holidayType.image" />
        <dropdown
          v-if="isEditable"
          :key="timeOffType"
          v-model="timeOffType"
          :options="daysOffTypes()"
          @dropdown-opened="dropdownOpened"
          @input="changeTimeOffType"
        />
        <div v-else>{{ timeOffType }}</div>
      </div>
      <div class="popup-row">
        <img :src="require('@/assets/_desktop/_calendars/Calendar.svg')" />
        <date-picker2
          v-show="isEditable"
          v-model="date"
          :start-range-prop="moment(entry.start).toDate()"
          :end-range-prop="moment(entry.end).toDate()"
          picked-range
          :timezone="noworkTimezone"
          :user-timezone="$parent.userTimezone"
          @holiday-changed="changeHoliday"
        />
        <div v-if="!isEditable">{{ entryFormattedDate }}</div>
        <div class="duration">
          {{ holidayDuration > 0 ? $tc('dayPlural', holidayDuration) : '' }}
        </div>
      </div>
      <div v-if="noworkTimezone" class="popup-row">
        <img alt="Location" :src="require('@/assets/_desktop/_calendars/Time-zone.svg')" />
        <dropdown
          v-if="isEditable"
          :key="noworkTimezone"
          v-model="noworkTimezone"
          :disabled="false"
          :options="$store.state.timezonesGlobal"
          :editable="true"
          :show-all="true"
          :auto-complete="true"
          @focusout="textInput = false"
          @dropdown-opened="dropdownOpened"
          @input="changeTimezone"
          @writing="changingText"
        />
        <div v-else>{{ noworkTimezone }}</div>
      </div>
      <div v-if="isMyPersonal || inputComment" class="popup-row">
        <img alt="Comment" :src="require('@/assets/_desktop/_calendars/Comment.svg')" />
        <div class="textarea-wrapper">
          <textarea
            v-if="isEditable"
            id="commentId"
            v-model="inputComment"
            class="clavo-textarea"
            auto-capitalize="on"
            @focusout="changeComment"
            @focusin="textInput = true"
            @input="writingComment"
          />
          <div v-else class="comment-content">{{ inputComment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import Dropdown from '@/components/UI/Dropdown'
import * as UTILS from '@/components/utils'
import TeamIcon from '@/components/Team/TeamIcon'
import ParseFunctions from '@/components/ParseFunctions'
import moment from 'moment-timezone'
import DatePicker2 from '@/components/UI/DatePicker2/DatePicker2'
import Parse from 'parse'
import Constants from '@/components/Constants'
import EventBus from '@/EventBus'
import { getLocationsCached } from '@/components/cache'
import { resizingUpEntryBestFittingStart, resizingDownEntryBestFittingEnd } from '../../../clavo-shared/functions/collisions'
import { getWeekStartFromDate, calculateDisplayedRangeDate } from '../../../clavo-shared/functions/time'

export default {
  name: 'ScheduleEntryPopup',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Dropdown,
    TeamIcon,
    DatePicker2,
  },
  mixins: [ParseFunctions, Constants],
  props: {
    entry: {
      default: undefined,
      type: Object,
    },
    // schedulePopup: {
    //   default: undefined,
    //   type: Object,
    // },
    teams: {
      default: undefined,
      type: Array,
    },
    filteredTeams: {
      default: undefined,
      type: Array,
    },
    entries: {
      default: undefined,
      type: Array,
    },
    locationsProps: {
      default: undefined,
      type: Array,
    },
    isMyPersonal: {
      default: false,
      type: Boolean,
    },
    submittingEntries: {
      default: false,
      type: Boolean,
    },
    fetchingEntries: {
      default: false,
      type: Boolean,
    },
    isFarInFuture: {
      default: false,
      type: Boolean,
    },
    userTimezone: {
      default: undefined,
      type: String,
    },
  },
  data() {
    return {
      options: [{ name: '' }, { name: '' }],
      inputLocation: {
        name: '',
        color: '',
        timezone: '',
        id: '',
      },
      startTimeArray: [],
      endTimeArray: [],
      startTime: { name: '0:00', value: 0 },
      endTime: { name: '0:00', value: 0 },
      hour_height: this.$parent.hour_height,
      date: moment().toDate(),
      team: {
        name: '',
      },
      inputTeam: '',
      entryInPopup: {},
      inputComment: '',
      locations: [],
      textInput: false,
      commentChanged: false,
      lastUsedSettings: {},
      holidayDuration: 1,
      noworkTimezone: undefined,
      timeOffType: 'holiday',
      is24h: false,
      preventEntryDelete: false,
      isCopyPossible: false,
      showCopied: false,
    }
  },
  computed: {
    holidayType() {
      return this.daysOffTypes().find((x) => x.value === this.entry.type)
    },
    momentHourFormat() {
      if (this.is24h) {
        return 'HH:mm'
      } else {
        return 'h:mm a'
      }
    },
    entryFormattedDate() {
      if (this.entry.type == 'work') {
        let start = moment(this.entry.start).tz(this.userTimezone)
        let dayNameFormat = start.clone().calendar(null, this.texts().momentDayNames)
        let date
        if (dayNameFormat === 'Today') {
          date = start.formatLocalized('[Today], MMM D')
        } else if (dayNameFormat === 'Tomorrow') {
          date = start.formatLocalized('[Tomorrow], MMM D')
        } else if (dayNameFormat === 'Yesterday') {
          date = start.formatLocalized('[Yesterday], MMM D')
        } else {
          date = start.formatLocalized('dddd, MMM D')
        }

        // let date = start.format('dddd, MMM D')

        // let userStartOfWeek = this.$store.state.userStartOfWeek
        // let weekStart = getWeekStartFromDate(moment().toDate(),userStartOfWeek, this.entry.timezone)
        // if(weekStart.clone().isAfter(start) && weekStart.clone().subtract(1,'week').isBefore(start))
        //   date = this.$t('last') + ' ' + date
        // if(weekStart.clone().add(1,'week').isBefore(start) && weekStart.clone().add(2,'week').isAfter(start))
        //   date = this.$t('next') + ' ' + date
        return date
      } else {
        return calculateDisplayedRangeDate(this.entry.start, this.entry.end, this.entryInPopup.timezone, this.$i18n.locale)
      }
    },
    isEditable() {
      return this.isMyPersonal && !this.submittingEntries && !this.fetchingEntries
    },
  },
  watch: {},
  // async updated() {
  //   await this.locations
  //   this.$refs.entryPopupRef.focus()
  //   // console.log("mounted popup")
  //   this.$emit('popupMonted')
  // },
  async mounted() {
    // this.$refs.entryPopupRef.focus()
    this.commentChanged = false
    this.$emit('popupMounted')

    // resize comment text area
    this.$nextTick(() => {
      setTimeout(() => {
        let commentArea = document.getElementById('commentId')
        if (commentArea) {
          commentArea.style.height = Math.min(commentArea.scrollHeight + 2, 112) + 'px' // 112px of height allows up to 5 lines of text to fit
        }
      }, 400) // timeout, because without it sometimes commentArea.scrollHeight has too small values (as if there wasn't any text even though there is)
    })
  },
  async created() {
    this.is24h = this.$store.state.userSettings['is-24h']

    this.team = this.teams.find((x) => x.teamId === this.entry.teamId)

    this.$parent.$parent.setTeamInSummary(this.team)
    this.entryInPopup = this.entry

    this.inputTeam = this.team.name
    this.inputComment = this.entryInPopup.comment
    this.locations = this.locationsProps

    this.checkIfCopyPossible()

    if (this.entryInPopup.type !== 'work') {
      this.noworkTimezone = this.entryInPopup.timezone
      this.timeOffType = this.entry.type
    }

    this.inputLocation = this.entry.location
    if (!this.inputLocation.timezone) {
      if (this.entryInPopup.timezone) {
        this.inputLocation.timezone = this.entryInPopup.timezone
      } else {
        this.inputLocation.timezone = this.$parent.userTimezone
        this.entryInPopup.timezone = this.inputLocation.timezone
      }
    }

    this.updateTimeAndDateDropdowns()

    this.date = moment(this.entryInPopup.start).toDate()
  },
  methods: {
    dropdownOpened(input) {
      this.preventEntryDelete = input
    },

    changeTimeOffType(input) {
      let oldTimeOffType = this.entry.type
      this.timeOffType = input

      this.entry.type = input
      this.entryInPopup.type = input

      // update tempTimeOff value
      if (input === 'holiday' || oldTimeOffType === 'holiday') {
        let timeOffDurationInDays = moment(this.entryInPopup.end).diff(moment(this.entryInPopup.start), 'days')
        let tempTimeOffValue = this.$store.state.tempTimeOffChanges[this.entryInPopup.teamId] || 0

        if (input === 'holiday') {
          // changed time-off type to holiday - add time-off duration
          tempTimeOffValue += timeOffDurationInDays
        } else if (oldTimeOffType === 'holiday') {
          // changed time-off type from holiday to something else - subtract time-off duration
          tempTimeOffValue -= timeOffDurationInDays
        }

        this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: this.entryInPopup.teamId, value: tempTimeOffValue })
      }

      this.$emit('entryChanged', this.entryInPopup, 'type')
    },

    checkIfCopyPossible() {
      let entryInPopupLocationId = this.entryInPopup.location.id || this.entryInPopup.location.objectId // submitted entries have locations.id, new ones have .objectId
      let possibleLocationIds = this.locations.map((loc) => loc.objectId || loc.id)
      this.isCopyPossible = possibleLocationIds.includes(entryInPopupLocationId)
    },

    getTeamId() {
      return this.team.teamId
    },

    getEntryTimezone(entry) {
      if (entry.location && entry.location.timezone) {
        return entry.location.timezone
      } else if (entry.timezone) {
        return entry.timezone
      } else {
        return this.$parent.userTimezone
      }
    },

    updateTimeAndDateDropdowns() {
      if (this.entry.type === 'work') {
        this.makeTimeOptions()
      }
    },

    keyPressed(e) {
      if (!this.textInput && !this.preventEntryDelete) {
        if (e.key === 'Delete' || e.key === 'Backspace') {
          this.deleteEntry()
        }
      }
    },

    changeTimezoneForSingleEntry(entry) {
      let oldTimezone = entry.timezone
      let oldStart = entry.start
      let oldEnd = entry.end

      let oldStartTimezone = moment(oldStart).tz(oldTimezone)
      let oldStartY = oldStartTimezone.year()
      let oldStartM = oldStartTimezone.month()
      let oldStartD = oldStartTimezone.date()
      let oldStartHour = oldStartTimezone.hour()
      let oldStartMin = oldStartTimezone.minutes()

      let oldEndTimezone = moment(oldEnd).tz(oldTimezone)
      let oldEndY = oldEndTimezone.year()
      let oldEndM = oldEndTimezone.month()
      let oldEndD = oldEndTimezone.date()
      let oldEndHour = oldEndTimezone.hour()
      let oldEndMin = oldEndTimezone.minutes()

      let newStart = moment(oldStart).tz(this.noworkTimezone).set('year', oldStartY).set('month', oldStartM).set('date', oldStartD)
      newStart.set('hour', oldStartHour).set('minutes', oldStartMin)

      let newEnd = moment(oldEnd).tz(this.noworkTimezone).set('year', oldEndY).set('month', oldEndM).set('date', oldEndD)
      newEnd.set('hour', oldEndHour).set('minutes', oldEndMin)

      entry.start = newStart.toDate()
      entry.end = newEnd.toDate()
      entry.timezone = this.noworkTimezone
      this.$emit('entryChanged', entry, 'timezone', { timezone: oldTimezone, start: oldStart, end: oldEnd })
    },

    changeTimezone() {
      if (this.entryInPopup.type != 'work') {
        this.changeTimezoneForSingleEntry(this.entryInPopup)
      } else {
        this.entryInPopup.timezone = this.inputLocation.timezone
        this.$emit('entryChanged', this.entryInPopup, 'timezone')
      }
      localStorage.entryTimezoneEdited = this.inputLocation.timezone
    },

    changeHoliday(entryRange, holidayEntries, holidayDuration) {
      if (holidayEntries === null) {
        this.deleteEntry()
      } else {
        // update tempTimeOff
        let oldTimeOffDuration = this.holidayDuration
        this.holidayDuration = holidayDuration
        let tempTimeOff = this.$store.state.tempTimeOffChanges[this.entryInPopup.teamId] || 0
        tempTimeOff = tempTimeOff - oldTimeOffDuration + holidayDuration
        this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: this.entryInPopup.teamId, value: tempTimeOff })

        for (var i = 1; i < holidayEntries.length; i++) {
          this.$emit('createEntryCopy', this.entry, holidayEntries[i][0], holidayEntries[i][1])
        }

        this.$emit('holiday-changed', this.entry, holidayEntries[0])
        this.$emit('entryChanged', this.entryInPopup, 'time', { holidayEntries })
      }
    },
    deleteEntry() {
      if (!this.isEditable) return
      this.$emit('deleteEntry', this.entry)
    },

    copyEntry() {
      let copiedEntry = {
        type: this.entryInPopup.type,
        teamId: this.entryInPopup.teamId,
        location: this.entryInPopup.location,
        durationInMinutes: moment.duration(moment(this.entryInPopup.end).diff(moment(this.entryInPopup.start))).asMinutes(),
        timezone: this.entryInPopup.timezone,
      }
      this.$store.commit('setCopiedEntry', copiedEntry)

      this.showCopied = true
      setTimeout(() => {
        this.showCopied = false
      }, 1000)
    },

    changeComment() {
      this.textInput = false
      this.entryInPopup.comment = this.inputComment
      this.$emit('entryChanged', this.entryInPopup, 'comment')
    },

    changeType(type) {
      if (type == 'work' && this.isFarInFuture) {
        EventBus.$emit('clear-info-bars')
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('canOnlyScheduleWorkForCurrentAndNextWeek'),
          error: true,
        })
        return
      }

      if (this.entry.type == type) return

      if (this.entry.type != 'work') {
        // change entry type from time-off to work
        let oldTimeOffDurationInDays = moment(this.entryInPopup.end).diff(moment(this.entryInPopup.start), 'days')
        let oldType = this.entry.type

        this.entry.type = type
        this.entryInPopup.type = type
        this.lastUsedSettings.startFree = moment(this.entry.start)
        this.lastUsedSettings.endFree = moment(this.entry.end)
        this.lastUsedSettings.noworkTimezone = this.entry.timezone
        let start = this.lastUsedSettings.startWork
          ? this.lastUsedSettings.startWork
          : moment(this.entryInPopup.start).tz(this.$parent.userTimezone).startOf('day')
        let end = this.lastUsedSettings.endWork ? this.lastUsedSettings.endWork : moment(start).add(8, 'hours')
        this.entryInPopup.start = start.toDate()
        this.entryInPopup.end = end.toDate()
        this.inputLocation = this.entryInPopup.location
        this.entryInPopup.location = this.inputLocation
        if (!this.inputLocation.timezone) {
          if (this.lastUsedSettings.timezoneWork) {
            this.inputLocation.timezone = this.lastUsedSettings.timezoneWork
          } else {
            this.inputLocation.timezone = this.$parent.userTimezone
          }
        }
        this.entryInPopup.timezone = this.inputLocation.timezone
        this.makeTimeOptions()

        // update tempTimeOff
        if (oldType === 'holiday') {
          let tempTimeOffValue = this.$store.state.tempTimeOffChanges[this.entryInPopup.teamId] || 0
          tempTimeOffValue -= oldTimeOffDurationInDays
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: this.entryInPopup.teamId, value: tempTimeOffValue })
        }
      } else {
        // change entry type from work to time-off
        // NO WORK
        this.entry.type = type
        this.entryInPopup.type = type
        this.entryInPopup.timezone = this.lastUsedSettings.noworkTimezone ? this.lastUsedSettings.noworkTimezone : Parse.User.current().get('timezone')
        this.noworkTimezone = this.entryInPopup.timezone
        this.lastUsedSettings.startWork = moment(this.entry.start)
        this.lastUsedSettings.endWork = moment(this.entry.end)
        this.lastUsedSettings.timezoneWork = this.inputLocation.timezone
        let start = this.lastUsedSettings.startFree
          ? this.lastUsedSettings.startFree
          : moment(this.entryInPopup.start).tz(this.entryInPopup.timezone).startOf('day')
        let end = this.lastUsedSettings.endFree ? this.lastUsedSettings.endFree : moment(start).add(1, 'days')
        this.entryInPopup.start = start.toDate()
        this.entryInPopup.end = end.toDate()

        // this.entryInPopup.location = undefined

        let teamHolidayInfo = this.$store.state.holidayInfo[Parse.User.current()._getId()].holidayInfo.find((team) => team.teamId == this.entryInPopup.teamId)
        if (teamHolidayInfo.holiday[moment().format('YYYY')].limit == undefined) {
          EventBus.$emit('open-holidays-popup', this.entryInPopup.teamId)
        }

        // update tempTimeOff
        if (this.entry.type === 'holiday') {
          let tempTimeOffValue = this.$store.state.tempTimeOffChanges[this.entryInPopup.teamId] || 0
          tempTimeOffValue += moment(this.entryInPopup.end).diff(moment(this.entryInPopup.start), 'days')
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: this.entryInPopup.teamId, value: tempTimeOffValue })
        }
      }
      this.$emit('entryChanged', this.entryInPopup, 'type')
    },

    revertEntryToOldData(entry, oldData) {
      for (const [key, value] of Object.entries(oldData)) {
        entry[key] = value
      }
    },

    collidingEntriesFound(mode, oldData) {
      if (mode == 'timezone') {
        // revert entry
        this.revertEntryToOldData(this.entry, oldData)
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('noSpaceForChangedTimezonePleaseFix'),
          error: true,
        })
      } else if (mode == 'type') {
        if (this.entry.type != 'work') {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('noSpaceForFullDayEntryPleaseFix'),
            error: true,
          })
          this.changeType('work')
          this.$refs.typeWork.focus()
        } else {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('noSpaceForEntryPleaseFix'),
            error: true,
          })
          this.changeType(this.timeOffType)
          this.$refs.typeNoWork.focus()
        }
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('noSpaceForFullDayEntryPleaseFix'),
          error: true,
        })
      }
    },

    saveLastUsedSetting(key, value) {},

    writingComment(e) {
      if (!this.commentChanged) {
        this.commentChanged = true
        this.$emit('entryChanged', this.entryInPopup, 'comment')
      }
    },

    changingText(e) {
      this.textInput = true
    },

    changeLocation(location) {
      this.entryInPopup.location = location

      this.inputLocation = location
      localStorage.locationIdEdited = location.objectId
      localStorage.teamIdEdited = this.team.teamId
      if (!this.inputLocation.timezone) {
        this.inputLocation.timezone = this.$parent.userTimezone
      }
      this.entryInPopup.timezone = this.inputLocation.timezone
      this.$emit('entryChanged', this.entryInPopup, 'location')
      this.checkIfCopyPossible()
    },

    async changeTeam(input) {
      let oldTeamId = this.team.teamId
      this.inputTeam = input
      this.team = this.teams.find((x) => x.name === input)
      this.$parent.$parent.setTeamInSummary(this.team)
      this.locations = await getLocationsCached(this.team, this.getLocations)
      this.inputLocation = { ...this.locations[0] }
      if (!this.inputLocation.timezone) {
        this.inputLocation.timezone = this.$parent.userTimezone
      }
      this.entryInPopup.timezone = this.inputLocation.timezone
      this.entryInPopup.teamId = this.team.teamId
      if (this.locations[0]) {
        localStorage.teamIdEdited = this.team.teamId
      }

      this.entryInPopup.location = this.inputLocation

      this.$emit('entryChanged', this.entryInPopup, 'team')

      if (this.entryInPopup.type != 'work') {
        let teamHolidayInfo = this.$store.state.holidayInfo[Parse.User.current()._getId()].holidayInfo.find((team) => team.teamId == this.entryInPopup.teamId)
        if (teamHolidayInfo.holiday[moment().format('YYYY')].limit == undefined) {
          EventBus.$emit('open-holidays-popup', this.entryInPopup.teamId)
        }

        if (this.entryInPopup.type === 'holiday') {
          // update tempTimeOff values
          let timeOffDurationInDays = moment(this.entryInPopup.end).diff(moment(this.entryInPopup.start), 'days')
          let oldTeamTempTimeOffValue = this.$store.state.tempTimeOffChanges[oldTeamId] || 0
          let newTeamTempTimeOffValue = this.$store.state.tempTimeOffChanges[this.entryInPopup.teamId] || 0
          oldTeamTempTimeOffValue -= timeOffDurationInDays
          newTeamTempTimeOffValue += timeOffDurationInDays
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: oldTeamId, value: oldTeamTempTimeOffValue })
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: this.entryInPopup.teamId, value: newTeamTempTimeOffValue })
        }
      }
      this.checkIfCopyPossible()
    },

    makeTimeOptions() {
      let timezone = this.getEntryTimezone(this.entryInPopup)
      this.startTime.name = moment(this.entryInPopup.start).tz(timezone).format(this.momentHourFormat).toUpperCase()
      this.endTime.name = moment(this.entryInPopup.end).tz(timezone).format(this.momentHourFormat).toUpperCase()

      this.startTime.duration = this.longerDurationFormat(this.entryInPopup.start, this.entryInPopup.end)
      this.endTime.duration = this.startTime.duration

      this.startTimeArray = []
      this.endTimeArray = []
      const MINUTES_THRESHHOLD = 60 * 24
      const HOURS24 = 1000 * 60 * 60 * 24
      let down24HEntry = { ...this.entryInPopup }
      let up24HEntry = { ...this.entryInPopup }
      down24HEntry.end = new Date(down24HEntry.start.getTime() + HOURS24)
      up24HEntry.start = new Date(up24HEntry.end.getTime() - HOURS24)

      let maxDownEntry = resizingDownEntryBestFittingEnd(this.entries, down24HEntry, MINUTES_THRESHHOLD)
      let maxUpEntry = resizingUpEntryBestFittingStart(this.entries, up24HEntry, MINUTES_THRESHHOLD)

      for (let i = moment(maxUpEntry.start); i.isBefore(moment(this.entryInPopup.end)); i.add(15, 'minutes')) {
        this.startTimeArray.push({
          name: i.tz(timezone).format(this.momentHourFormat).toString().toUpperCase(),
          value: i.toDate(),
        })
      }

      for (let i = moment(this.entryInPopup.start).add(15, 'minutes'); i.isSameOrBefore(moment(maxDownEntry.end)); i.add(15, 'minutes')) {
        this.endTimeArray.push({
          name: i.tz(timezone).format(this.momentHourFormat).toString().toUpperCase(),
          value: i.toDate(),
          description: '(' + this.longerDurationFormat(this.entryInPopup.start, i.toDate(), true) + ')',
        })
      }
    },

    changeTime(input, type) {
      if (type === 'start') {
        this.entryInPopup.start = input
      }
      if (type === 'end') {
        this.entryInPopup.end = input
      }
      this.$emit('entryChanged', this.entryInPopup, 'time')
      this.makeTimeOptions()
    },
  },
}
</script>

<style scoped lang="scss">
.entryPopup {
  width: 338px;
  padding: 24px;
  border: 1px solid $flax-bloom;
  background-color: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  outline: none;

  @include respond-below(sm) {
    border-bottom: 0;
    border-left: 0;
    border-right: 0;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
  }

  .button-icon {
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 14px;

    &:hover {
      background-color: $white-lilac;
    }
    &:focus {
      background-color: $white-lilac;
      outline: none;
    }
    &.close-button {
      right: 18px;
    }
    &.delete-button {
      right: 18px + 36px + 6px;
    }
    &.copy-button {
      right: 18px + 2 * (36px + 6px);
      .copied {
        font-family: $semibold;
        background: $blue;
        position: absolute;
        padding: 6px 10px;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 6px;
        color: white;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
      }
    }
  }

  h4 {
    font-family: $semibold;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: -2px;
    margin-bottom: 24px;
    width: 58%;
  }
  .popup-row {
    display: grid;
    grid-template-columns: 24px auto;
    grid-column-gap: 18px;
    margin-bottom: 18px;
    align-items: center;
    img {
      // margin-top: 7px;
    }

    > div {
      font-size: 14px;
    }

    .switch {
      display: flex;
      grid-column: 2;
    }

    .multiple {
      display: flex;
      img {
        margin: 0 12px;
      }
    }

    .textarea-wrapper {
      overflow-x: auto;
      .clavo-textarea {
        height: 41px;
        transition: height 0.36s;
      }
      .comment-content {
        max-height: 100px;
        overflow-y: auto;
        overflow-wrap: break-word;
      }
    }

    .duration {
      grid-column-start: 2;
      font-size: 14px;
      color: $bluebell;
      line-height: 20px;
      margin-top: 6px;
    }

    .circle-location {
      width: 14px;
      height: 14px;
      border-radius: 14px;
      align-self: center;
      justify-self: center;
    }
  }
}
</style>
